<template>
    <div>
        <div class="head">
            <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
        </div>
        <div class="content">
            <el-table
                    :data="riskUnitStopList"
                    :header-cell-style="{ background: 'rgb(250,250,250)' }"
                    style="width: 100%">
                <el-table-column label="风险分析单元" align="center" prop="riskUnit.riskUnitName" />
                <el-table-column label="原因" align="center" prop="stopReason" />
                <el-table-column label="创建时间" align="center" prop="createTime" width="180">
                    <template slot-scope="{ row }">
                        <span v-if="row.createTime">{{ row.createTime | timeFilter }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                        <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
                        <span style="margin: 0 5px;color: #e8e8e8">|</span>
<!--                        <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>-->
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 15px">
                <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
            </div>
        </div>

        <!-- 添加或修改风险四色图管理对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                <el-form-item label="风险分析单元" prop="riskUnitId">
                    <el-select v-model="form.riskUnitId" placeholder="请选择风险分析单元">
                        <el-option
                                v-for="dict in riskUnitList"
                                :key="dict.riskUnitId"
                                :label="dict.riskUnitName"
                                :value="dict.riskUnitId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="停用开始时间" prop="stopStartTime">
                    <el-date-picker size="small"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-model="form.stopStartTime"
                                    type="datetime" style="width: 50%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="停用结束时间" prop="stopEndTime">
                    <el-date-picker size="small"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-model="form.stopEndTime"
                                    type="datetime" style="width: 50%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="原因" prop="stopReason">
                    <el-input v-model="form.stopReason" placeholder="请输入原因"/>
                </el-form-item>
                <el-form-item label="创建人" prop="creator">
                    <el-input v-model="form.creator" placeholder="请输入创建人"/>
                </el-form-item>
                <el-form-item label="数据对接省厅" prop="isTest">
                    <el-select v-model="form.isTest" style="width: 100%">
                        <el-option :value="1" label="否"/>
                        <el-option :value="0" label="是"/>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import { listRiskUnitStop, getRiskUnitStop, delRiskUnitStop, addRiskUnitStop, updateRiskUnitStop } from "@/api/doublePrevention/riskUnitStop";
    import { listRiskUnit } from "@/api/doublePrevention/riskUnit";

    export default {
        name: 'ProcessRawMaterials',
        data() {
            return {
                // searchContent: '',
                riskUnitStopList: [],
                riskUnitList: [],
                total: 0,
                curPage: 1,
                pageSize: 10,
                open: false,
                form: {},
                rules: {},
                title: null
            }
        },
        created() {
            this.getRiskUnitStopList();
            this.getRiskUnitList();
        },
        methods: {
            getRiskUnitStopList() {
                listRiskUnitStop({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
                    this.riskUnitStopList = res.body.data
                    this.total = res.body.cum
                })
            },
            getRiskUnitList(){
                listRiskUnit().then(res => {
                    this.riskUnitList = res.body.data
                })
            },
            pageChange(val) {
                this.curPage = val;
            },
            addBtn() {
                this.reset()
                this.open = true
                this.title = '添加风险分析单元管理'
            },
            editBtn(row) {
                this.reset()
                const recordId = row.recordId
                getRiskUnitStop(recordId).then(response => {
                    this.form = response.body.data
                    this.open = true
                    this.title = '修改风险分析单元管理'
                })
            },
           /* deleteBtn(row) {
                delRiskUnitStop(row.recordId).then(res => {
                    this.$message.success('删除成功')
                })
            },*/
            // 取消按钮
            cancel() {
                this.open = false
                this.reset()
            },
            // 表单重置
            reset() {
                this.form = {
                    recordId: null,
                    //enterpriseId: null,
                    riskObjectId: null,
                    riskUnitId: null,
                    stopStartTime:null,
                    stopEndTime: null,
                    stopReason: null,
                    companyCode: null,
                    createTime: null,
                    creator: null,
                    recordStatus: null,
                    isTest: null
                }
            },
            /** 提交按钮 */
            submitForm() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        if (this.form.recordId != null) {
                            updateRiskUnitStop(this.form).then(response => {
                                this.open = false
                            })
                        } else {
                            addRiskUnitStop(this.form).then(response => {
                                this.open = false
                            })
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .head {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 280px);
    }
    .btn {
        cursor: pointer;
    }
</style>
